module.exports = __webpack_public_path__ + "media/bootstrap-icons/journals-1b1b7291.svg";